import { api } from "./api";
export interface ContentArticle {
  id: number;
  title: string;
  status: string;
  progress: number;
  error_message?: string;
  editorial_stage: "draft" | "review" | "ready";
  editorial_owner: number | null;
  due_date: string | null;
  meta_title: string;
  meta_description: string;
  keywords: string;
}
export const ACTIVE_CONTENT_STATUSES = [
  "pending",
  "seo_done",
  "outline_done",
  "brief_done",
];
export async function contentPages<T>(path: string): Promise<T[]> {
  const results: T[] = [];
  for (let page = 1; ; page += 1) {
    const response = await api.get<T[] | { results: T[]; next: string | null }>(
      `${path}${path.includes("?") ? "&" : "?"}page=${page}`,
    );
    if (Array.isArray(response.data)) return response.data;
    results.push(...response.data.results);
    if (!response.data.next) return results;
  }
}
export function downloadContent(text: string, name: string, type: string) {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
